import { AppScreenEnum, PromoCodeStatusEnum, PromotionProductEnum, PromotionStatusEnum } from '@/enums';
import type { TPackageRow } from '@/interfaces';

/* The title of the promotion sheet in the app: one line on a phone. The API refuses longer */
export const PROMOTION_TITLE_MAX_LENGTH = 28;
/* Its description: two lines on a phone */
export const PROMOTION_DESCRIPTION_MAX_LENGTH = 80;

/* The API refuses a percentage bonus above this */
export const PROMO_CODE_MAX_PERCENT_BONUS = 80;

export const PROMO_CODE_STATUS_CONFIG: Record<PromoCodeStatusEnum, { label: string; className: string }> = {
	[PromoCodeStatusEnum.SCHEDULED]: { label: 'Programmée', className: 'bg-blue-100 text-blue-700 border-transparent' },
	[PromoCodeStatusEnum.ACTIVE]: { label: 'Active', className: 'bg-green-100 text-green-700 border-transparent' },
	[PromoCodeStatusEnum.EXPIRED]: { label: 'Expirée', className: 'bg-muted text-muted-foreground border-transparent' },
	[PromoCodeStatusEnum.DISABLED]: { label: 'Désactivée', className: 'bg-red-100 text-red-700 border-transparent' }
};

export const PROMOTION_PRODUCT_LABELS: Record<PromotionProductEnum, string> = {
	[PromotionProductEnum.BOOST]: 'Boost',
	[PromotionProductEnum.COINS]: 'Coins',
	[PromotionProductEnum.INCOGNITO]: 'Incognito'
};

export const PROMOTION_STATUS_CONFIG: Record<PromotionStatusEnum, { label: string; className: string }> = {
	[PromotionStatusEnum.PENDING]: { label: 'En attente', className: 'bg-amber-100 text-amber-700 hover:bg-amber-100' },
	[PromotionStatusEnum.ACTIVE]: { label: 'En cours', className: 'bg-green-100 text-green-700 hover:bg-green-100' },
	[PromotionStatusEnum.FINISHED]: { label: 'Terminé', className: 'bg-gray-100 text-gray-500 hover:bg-gray-100' }
};

export const PROMOTION_PRODUCT_PACKAGES: Partial<Record<string, TPackageRow[]>> = {
	COINS: [
		{ name: 'Bronze', baseValue: 800, unit: 'coins' },
		{ name: 'Silver', baseValue: 3_000, unit: 'coins' },
		{ name: 'Gold', baseValue: 6_500, unit: 'coins' },
		{ name: 'Diamond', baseValue: 20_000, unit: 'coins' }
	],
	BOOST: [
		{ name: '1h', baseValue: 60, unit: 'min' },
		{ name: '6h', baseValue: 360, unit: 'min' },
		{ name: '24h', baseValue: 1_440, unit: 'min' }
	],
	INCOGNITO: [
		{ name: '1 mois', baseValue: 1, unit: 'mois' },
		{ name: '3 mois', baseValue: 3, unit: 'mois' },
		{ name: '6 mois', baseValue: 6, unit: 'mois' }
	]
};

export const PROMOTION_PRODUCT_OPTIONS = [
	{ value: PromotionProductEnum.BOOST, label: 'Boost' },
	{ value: PromotionProductEnum.COINS, label: 'Coins' },
	{ value: PromotionProductEnum.INCOGNITO, label: 'Incognito' }
];

export const APP_SCREEN_OPTIONS: { value: AppScreenEnum; title: string }[] = [
	{ value: AppScreenEnum.BUY_COINS, title: 'Acheter des coins' },
	{ value: AppScreenEnum.BOOST_MODAL, title: 'Booster son profil' },
	{ value: AppScreenEnum.INCOGNITO_MODAL, title: 'Mode incognito' },
	{ value: AppScreenEnum.REWARD_COINS, title: 'Gagner des coins' },
	{ value: AppScreenEnum.WALLET, title: 'Portefeuille' },
	{ value: AppScreenEnum.HOME, title: 'Accueil (Rencontres)' },
	{ value: AppScreenEnum.CHAT, title: 'Discussions' },
	{ value: AppScreenEnum.ACTIVITY, title: 'Activité' },
	{ value: AppScreenEnum.PROFILE, title: 'Mon profil' },
	{ value: AppScreenEnum.LIKES, title: 'Likes reçus' },
	{ value: AppScreenEnum.VIEWS, title: 'Vues' },
	{ value: AppScreenEnum.FAVORITES, title: 'Favoris' },
	{ value: AppScreenEnum.SETTINGS, title: 'Paramètres' },
	{ value: AppScreenEnum.NOTIFICATIONS, title: 'Notifications' },
	{ value: AppScreenEnum.REFERRAL, title: 'Parrainage' }
];
